import { Container, Grid, styled } from '@mui/material';
import { isNull, isUndefined } from 'lodash';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BreadcrumbWithBtnBack from 'src/components/BreadcrumbWithBtnBack';

// Components
import TabComponent from 'src/components/Tab/TabComponent';
import PeopleDetailCompanyRelated from 'src/features/PeopleDetail/CompanyRelated';
import PeopleDetailOverview from 'src/features/PeopleDetail/Overview';
import PeopleDetailPeopleRelated from 'src/features/PeopleDetail/PeopleRelated';
import PeopleDetailUserInfoPanel from 'src/features/PeopleDetail/UserInfoPanel';

// Utilities
import analytics from 'src/analytics';
import SkeletonOverview from 'src/features/CompanyDetail/OverView/SkeletonOverview';
import Alerts from 'src/features/PeopleDetail/Alerts';
import { PEOPLE_DETAIL_TABS, PEOPLE_DETAIL_TAB_KEYS } from 'src/features/PeopleDetail/config';
import { useGetPointsFeature } from 'src/hooks/useGetPointsFeature';
import useRefetch from 'src/hooks/useRefetch';
import { useMutateCheckEntityPaid } from 'src/services/mutate';
import { QUERY_KEY_USAGE, useQueryPeopleDetail, useQueryUsageInformation } from 'src/services/queries';
import { SKIP_ASK_PAY_CREDIT } from 'src/utils/constants/config';
import { TypeCheckEntityPaid } from 'src/utils/constants/enum';
import { LIST_ACTIONS, LIST_FEATURES } from 'src/utils/constants/featuresPoint';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { ERROR_CODE } from 'src/utils/constants/statusCode';
import { convertToStartCase } from 'src/utils/helpers/stringHelpers';
import { NotifyType, useNotifyCreditCosts } from 'src/zustand/useNotifyCreditCosts';
import EmailValidation from 'src/features/PeopleDetail/EmailValidation';
import FormContributePeople from 'src/features/PeopleDetail/Common/FormContributePeople';
import { usePeopleContribute } from 'src/zustand/usePeopleContribute';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(7),
}));

const PeopleDetail = () => {
  const [selectedTab, setSelectedTab] = useState(PEOPLE_DETAIL_TAB_KEYS.overview);
  /** acceptGetDetail values:
   * _ Initial value: null
   * _ When we accept to get data: true
   * _ After fetch data successfully: done
   */
  const [acceptGetDetail, setAcceptGetDetail] = useState<string | boolean | null>(null);
  const { handleOpenNotify, handleCloseNotify } = useNotifyCreditCosts((state) => state);
  const { open, type, handleCloseContribute } = usePeopleContribute((state) => state);

  const { id = '' } = useParams();
  const { data, isFetching } = useQueryPeopleDetail(id, acceptGetDetail === true);
  const { data: dataUsage } = useQueryUsageInformation();
  const navigate = useNavigate();
  const location = useLocation();
  const { refetchQuery } = useRefetch();
  // const { mutateAsync } = useMutateCheckEntityPaid();
  // const pointsViewPeople = useGetPointsFeature(LIST_FEATURES.PEOPLE_SEARCH_OVERVIEW, LIST_ACTIONS.VIEW, dataUsage);
  const hasHistoryEntryExist = location.key !== 'default'; // false => chuyển từ 1 trang ngoài Adamftd qua

  useEffect(() => {
    setAcceptGetDetail(true);
  }, []);

  // useEffect(() => {
  //   const fetchCheckPaid = async () => {
  //     try {
  //       const response = await mutateAsync({
  //         entityId: id,
  //         type: TypeCheckEntityPaid.PEOPLE,
  //       });
  //       setAcceptGetDetail(response?.check_entity_id_type_created_30_days_result || false);
  //     } catch (error) {
  //       setAcceptGetDetail(false);
  //     }
  //   };
  //   if (!id) {
  //     navigate(AuthRouteKeys.Home);
  //   } else {
  //     fetchCheckPaid();
  //   }
  //   setAcceptGetDetail(null);
  // }, [id]);

  // useEffect(() => {
  //   // After fetch data done
  //   if (isFetching === false) {
  //     setAcceptGetDetail('done');
  //   }
  // }, [isFetching]);

  useEffect(() => {
    if (
      [
        ERROR_CODE.NO_HAVE_ANY_CREDIT,
        ERROR_CODE.NO_HAVE_ENOUGH_CREDIT,
        ERROR_CODE.REACH_LIMIT_CREDITS,
        ERROR_CODE.RUN_OUT_OF_CREDIT,
      ].includes(data?.status_code)
    ) {
      handleOpenNotify({
        type: NotifyType.NotEnoughCredit,
        showCloseIcon: true,
        cbClose: () => {
          if (hasHistoryEntryExist) {
            navigate(-1);
          } else {
            navigate(AuthRouteKeys.Home);
          }
        },
      });
      return;
    }
  }, [data?.status_code]);

  // useEffect(() => {
  //   const skipAskPayCredit = localStorage.getItem(SKIP_ASK_PAY_CREDIT);
  //
  //   // Users haven't bought plans yet.
  //   if (!isNull(acceptGetDetail) && !acceptGetDetail && isUndefined(pointsViewPeople?.planName)) {
  //     handleOpenNotify({
  //       type: NotifyType.NotEnoughCredit,
  //       showCloseIcon: true,
  //       cbClose: () => {
  //         if (hasHistoryEntryExist) {
  //           navigate(-1);
  //         } else {
  //           navigate(AuthRouteKeys.Home);
  //         }
  //       },
  //     });
  //     return;
  //   }
  //
  //   // Users don't want show popup confirm credit expenditures.
  //   if (!isNull(acceptGetDetail) && !acceptGetDetail && (skipAskPayCredit || pointsViewPeople?.creditCosts === 0)) {
  //     setAcceptGetDetail(true);
  //     return;
  //   }
  //
  //   if (!isNull(acceptGetDetail) && !acceptGetDetail && pointsViewPeople?.creditCosts > 0) {
  //     handleOpenNotify({
  //       type: NotifyType.CreditCost,
  //       textBtn: 'View Profile Detail',
  //       creditCost: pointsViewPeople?.creditCosts,
  //       showCloseIcon: true,
  //       cbClose: () => {
  //         if (hasHistoryEntryExist) {
  //           navigate(-1);
  //         } else {
  //           navigate(AuthRouteKeys.Home);
  //         }
  //       },
  //       cbAction: () => {
  //         setAcceptGetDetail(true);
  //         handleCloseNotify();
  //       },
  //     });
  //   }
  // }, [acceptGetDetail, pointsViewPeople?.planName, pointsViewPeople?.creditCosts]);

  const renderTab = () => {
    switch (selectedTab) {
      case PEOPLE_DETAIL_TAB_KEYS.overview:
        return <PeopleDetailOverview dataPeople={data?.data} isFetching={isFetching} />;
      case PEOPLE_DETAIL_TAB_KEYS.company_related:
        return <PeopleDetailCompanyRelated />;
      case PEOPLE_DETAIL_TAB_KEYS.people_related:
        return <PeopleDetailPeopleRelated id={id} />;
      case PEOPLE_DETAIL_TAB_KEYS.alerts:
        return <Alerts />;
      case PEOPLE_DETAIL_TAB_KEYS.email_validation:
        return <EmailValidation />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (!data?.data?.full_name) return;
    analytics.logEvent('page_view', {
      page_title: `People Detail - ${data?.data?.full_name}`,
      page_location: window.location.href,
      page_path: window.location.pathname,
    });

    // get Usage after have data company
    refetchQuery([QUERY_KEY_USAGE]);
  }, [data?.data?.full_name]);

  if (
    !acceptGetDetail ||
    [
      ERROR_CODE.NO_HAVE_ANY_CREDIT,
      ERROR_CODE.NO_HAVE_ENOUGH_CREDIT,
      ERROR_CODE.REACH_LIMIT_CREDITS,
      ERROR_CODE.RUN_OUT_OF_CREDIT,
    ].includes(data?.status_code)
  ) {
    return (
      <StyledContainer maxWidth="xl">
        <SkeletonOverview />
      </StyledContainer>
    );
  }
  return (
    <StyledContainer maxWidth={'xl'}>
      {open && (
        <FormContributePeople peopleData={data?.data} open={true} type={type} handleClose={handleCloseContribute} />
      )}
      <Grid spacing={3} container>
        <Grid xs={12} item>
          <BreadcrumbWithBtnBack
            listItem={[
              {
                text: 'People',
              },
              {
                text: convertToStartCase(data?.data?.country_name || ''),
              },
              {
                text: convertToStartCase(data?.data?.full_name || ''),
              },
            ]}
            updatedAt={data?.data?.updated_at || ''}
          />
        </Grid>

        <Grid xs={12} item>
          <SectionErrorBoundary resetKey="PeopleDetailUserInfoPanel" sectionName="PeopleDetailUserInfoPanel">
            <PeopleDetailUserInfoPanel dataPeople={data?.data} isFetching={isFetching} />
          </SectionErrorBoundary>
        </Grid>

        <Grid xs={12} item>
          <TabComponent
            selected={selectedTab}
            handleChange={(_, e: string) => {
              setSelectedTab(e as PEOPLE_DETAIL_TAB_KEYS);
            }}
            tabs={PEOPLE_DETAIL_TABS}
          />
        </Grid>

        <SectionErrorBoundary resetKey={selectedTab} sectionName={`PeopleDetail-${selectedTab}`}>
          {renderTab()}
        </SectionErrorBoundary>
      </Grid>
    </StyledContainer>
  );
};

export default PeopleDetail;
